import { useEffect, useState } from 'react';
import Logger from '@lmig/dotcom-utilities-helpers/logger';

/**
 * Dynamically loads an external script.  Returns an error if valid url not passed.
 *
 * @param {String} src URL of script
 */

const logger = new Logger('client:useScript');

const useScript = (url, id) => {
  const [state, setState] = useState({
    loaded: false,
    error: false,
  });

  if (!url || url.length === 0) {
    throw new Error('useScript requires a valid url');
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (document.querySelector(`script[src="${url}"]`)) {
      logger.info(`${url} previously loaded.  not loaded again`);
      setState({ loaded: true, error: false });
    } else {
      logger.info(`${url} NOT previously loaded.  Initiating load`);

      // Create script
      const script = document.createElement('script');
      script.id = id;
      script.src = url;
      script.async = true;

      const onScriptLoad = () => {
        setState({ loaded: true, error: false });
      };

      const onScriptError = () => {
        setState({ loaded: true, error: true });
        script.remove();
      };

      script.addEventListener('load', onScriptLoad);
      script.addEventListener('error', onScriptError);

      // Add script to document body
      document.body.appendChild(script);

      return () => {
        script.removeEventListener('load', onScriptLoad);
        script.removeEventListener('error', onScriptError);
      };
    }
  }, [url, id]);

  return [state.loaded, state.error];
};

export default useScript;
